import { Dialog, DialogContent, useTheme } from '@mui/material';
import { FormProvider, useFormState } from 'react-hook-form';

import DialogBackNextActions from '~/components/DialogBackNextActions';
import DialogTitleWithCloseButton from '~/components/DialogTitleWithCloseButton';
import { invoiceKindToUploadDocumentType } from '~/components/uploadDocument/AddManuallyDropdown';
import { useInvoiceForm } from '~/components/uploadDocument/InvoiceForm';
import type { InvoiceForm, InvoiceKindKey } from '~/data/schemas/invoice';

interface IInvoiceDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data?: InvoiceForm) => void;
  isEdit?: boolean;
  defaultValues?: InvoiceForm;
  kind: InvoiceKindKey;
  overPage?: boolean;
}

const InvoiceDialog = ({
  open,
  onClose,
  onSubmit,
  isEdit,
  defaultValues,
  kind,
  overPage = false,
}: IInvoiceDialogProps) => {
  const theme = useTheme();
  const documentType = invoiceKindToUploadDocumentType[kind];
  const { Fields: InvoiceFields, Form: InvoiceForm, hookForm } = useInvoiceForm();
  const { isSubmitting } = useFormState({ control: hookForm.control });

  const title = `${isEdit ? 'Edit' : 'Add'} ${documentType}`;
  const actionBtns = {
    next: { label: 'Save', loading: isSubmitting },
  };

  const content = (
    <>
      <DialogTitleWithCloseButton onClose={onClose} title={title} />
      <DialogContent
        sx={{ padding: theme.spacing(2), paddingTop: 0, overflow: 'auto', height: '100%' }}
      >
        <InvoiceFields />
      </DialogContent>
      <DialogBackNextActions onBack={onClose} actionBtns={actionBtns} />
    </>
  );

  return (
    <FormProvider {...hookForm}>
      {overPage ? (
        <Dialog
          open={open}
          onClose={onClose}
          maxWidth="sm"
          slotProps={{ paper: { sx: { '& > form': { minHeight: 0 } } } }}
        >
          <InvoiceForm onSubmit={onSubmit} initialData={defaultValues}>
            {content}
          </InvoiceForm>
        </Dialog>
      ) : (
        <InvoiceForm onSubmit={onSubmit} initialData={defaultValues}>
          <Dialog open={open} onClose={onClose} maxWidth="sm" disablePortal>
            {content}
          </Dialog>
        </InvoiceForm>
      )}
    </FormProvider>
  );
};

export default InvoiceDialog;
